import React, { Component } from 'react';
import { Link } from "react-router-dom";
import IndexAreas from '../index/IndexAreas';
import Header from '../components/Header.js';

class Areas extends Component {
    componentDidMount(){
    console.log(IndexAreas);
    window.startx();
  }
  render() {
  	return(
      <div id="page-wrapper">
        <div className="content ocultar crecer">
          <div className="container">
            <section id="five" className="wrapper style1 special fade-up">
              <header className="major">
                <h2>Al interior del museo</h2>
                <p>Contamos con diferentes salas temáticas en las que podrás aprender<br/> un poco de ciencia, de arte y tecnología.</p>
              </header>
              <div className="row iconosareas">
                { this._renderCard("internas") }
              </div>
              <header className="major">
                <h2>Al exterior del museo del museo</h2>
                <p>En las partes externas del museo podras encontrar más actividades como:</p>
              </header>
              <div className="row iconosareas">
                { this._renderCard("externas") }
              </div>
            </section>
          </div> 
        </div>
        <div id="page-wrapper">
          <div id="main" className="wrapper wrapperPurple style1">
            <div className="container">
              <header className="major">
                <h2>Servicios</h2>
                <p>Contamos con diferentes servicios para que tu visita sea más comoda y placentera.</p>
              </header>
              <Header/>
              <div className="row gtr-150">
                <div className="col-12">
                  <section id="content" className="ocultar crecer">
                    <div class="container">
                      <div class="row">
                        <div className="col-md-6">
                          <img class="iconoMedio" src="images/icnoAreaComida.png" alt="Comida"/>
                          <h3 className="espacio">Área de comida</h3>
                          <p>Para que te tomes un respiro en tu visita, Museo El Rehilete tiene diversos locales comerciales con variadas opciones para toda la familia. Antojitos, papas, dulces, paletas, helados y mucho más están disponibles para ti.</p>
                        </div>
                        <div className="col-md-6">
                          <img class="iconoMedio" src="images/iconoTienda.png" alt="Tienda"/>
                          <h3 className="espacio">Tienda de Souvenirs</h3>
                          <p>Después de vivir la experiencia del Museo El Rehilete, seguramente desearás llevarte un recuerdo a casa, por lo que podrás visitar la tienda, en la que encontrarás gran diversidad de artículos referentes a las distintas áreas del museo.</p>
                        </div>
                      </div>
                      <div class="row">
                        <div className="col-md-6">
                          <img class="iconoMedio" src="images/iconoMedicos.png" alt="Servicio Medico"/>
                          <h3 className="espacio">Servicio Médico</h3>
                          <p>Contamos con servicio médico para brindar a nuestros visitantes, atención de primeros auxilios en caso de requerirlo.</p>
                        </div>
                        <div className="col-md-6">
                          <img class="iconoMedio" src="images/iconoEstacionamiento.png" alt="Estacionamiento"/>
                          <h3 className="espacio">Estacionamiento</h3>
                          <p>Para comodidad de nuestros visitantes, contamos con un amplio estacionamiento gratuito para que puedas dejar tu vehículo durante tu visita y divertirte en familia en todas nuestras áreas.</p>
                        </div>
                      </div>
                    </div>
                  </section>
                  {/*<section>
                    <h3 className="espacio">Avisos de Privacidad</h3>
                    <p><span className="imagenes2 left "><a className="fas"></a></span>Avisos de Privacidad en base a la Ley de Protección de Datos Personales</p>
                    <ul className="actions">
                    <li><a href="" className=""></a></li>
                    </ul>
                    <ul className="actions">
                    <li><a href="/avisos/reservaciones.pdf" className="">Reservaciones</a></li>
                    </ul>
                    <ul className="actions">
                    <li><a href="/avisos/patrocinio.pdf" className="">Patrocinio</a></li>
                    </ul>
                    <ul className="actions">
                    <li><a href="/avisos/verano.pdf" className="">Talleres de Verano</a></li>
                    </ul>
                    <ul className="actions">
                    <li><a href="/avisos/cci.pdf" className="">Concurso Anual de Creatividad e Ingenio</a></li>
                    </ul>
                    <ul className="actions">
                    <li><a href="/avisos/tv.pdf" className="">Talleres Virtuales</a></li>
                    </ul>
                  </section>*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  	);
  }

  _renderCard = (label) => {
    const arr = IndexAreas[label];
    return arr.map((data, j) => {
      return (
        <Link to={"/areas/"+label+"/"+j} className="col-md-3 col-sm-6 col-12 ocultar">
          {/*<span className="icon alt major"><img src={"https://cdn.hidalgo.gob.mx/plantilla_secretarial/logos/areas/"+data.icon}></img></span>*/}
          <span className="icon alt major"><img src={"./images/iconosAreas/"+data.icon+".png"} alt="Icono"></img></span>
          <h3>{ data.area }</h3>
        </Link>
      );
    });
  };
}
 export default Areas;


